import "./SummaryViewEntryListItem.scss";
import { Typography } from '@mui/material';

import FlagButton from '../../FlagButton';
import makeStyles from '@mui/styles/makeStyles';
import TextWithReadMore from '../../../Utils/TextWithReadMore';
import Metadata from '../Metadata';
import { memo } from 'react';
import ImageLoadIfVisible from "../../Utils/ImageLoadIfVisible";
import BrokenImage from "../../Utils/BrokenImage";

const useStyles = makeStyles((theme) => ({
    root: {
        border: '1px solid rgba(255, 255, 255, 0.12)',
        backgroundColor: '#121212',
        borderRadius: '0px',
        margin: '0',
        [theme.breakpoints.up('md')]: {
            '&:hover': {
                border: '1px solid rgba(255, 255, 255, 0.12)',
                margin: '-1rem',
                padding: '2rem',
                backgroundColor: '#1e1e1e',
                color: theme.palette.secondary.contrastText
            },
            '&:hover .descriptionTag': {
                color: theme.palette.secondary.contrastText
            },
            '&:hover img': {
                borderColor: theme.palette.primary.main,
            }
        }
    },
    media: {
        border: '1px solid transparent',
    },
    actionArea: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(1.5),
        '& .MuiButtonBase-root': {
            marginRight: theme.spacing(1.5),
            paddingTop: theme.spacing(1.2),
            paddingBottom: theme.spacing(1.2),
        },
        '& .MuiButtonBase-root:hover': {
            marginRight: theme.spacing(1.5),
        }
    },
    entryInfo: {
        '& p span': {
            marginLeft: '10px',
            marginRight: '10px',
            wordWrap: 'breakWord',
            [theme.breakpoints.down('sm')]: {
                wordWrap: 'breakWord',
                marginLeft: '2px',
                marginRight: '2px',
            }
        },
        '&:hover': {
            display: 'block'
        }
    },
    flags: {
        display: "flex",
        flexWrap: "wrap",
        marginTop: theme.spacing(1.5),
        marginBottom: theme.spacing(1.5),
        '& .MuiChip-root': {
            marginRight: theme.spacing(1.2)
        }
    },
    mandatoryFlagWrap: {
        marginRight: theme.spacing(1),
    },
    entryDescription: {
        [theme.breakpoints.down('sm')]: {
            '& .descriptionTag': {
                color: theme.palette.secondary.contrastText
            }
        },
    },
    entryThumbnailLink: {
        display: "block",
    },
    [theme.breakpoints.down('md')]: {
        entryThumbnailLink: {
            width: '100%',
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2),
            paddingTop: theme.spacing(2)
        },
    },
    hide: {
        display: 'none'
    },
    lineHover: {
        display: "block",
        color: theme.palette.secondary.contrastText,
        textDecoration: 'none',
        '&:hover': {
            textDecoration: 'none'
        }
    },
}));

export default memo(function SummaryViewEntryListItem({ linkComponent, entry, categoryId = null, categoryName = null }) {
    const classes = useStyles();

    const LinkComponent = linkComponent;

    return (
        <div className={`${classes.root} SummaryViewEntryListItem`}>
            <div className={`SummaryViewEntryListItem__imgcol`}>
                <LinkComponent entry={entry} entryCategoryId={categoryId} className={classes.lineHover}>
                    {entry.primaryImage ? (
                        <ImageLoadIfVisible
                            className={`${classes.lineHover} ${classes.media}`}
                            src={entry.primaryImage}
                            alt={entry.title}
                        />
                    ):(
                        <BrokenImage className={`${classes.lineHover} ${classes.media}`} />
                    )}
                </LinkComponent>
            </div>
            <div className={`SummaryViewEntryListItem__metacontent`}>
                <div className={`SummaryViewEntryListItem__metacontentinner`}>
                    <Typography variant="h6">
                        <LinkComponent entry={entry} entryCategoryId={categoryId} className={classes.lineHover}>
                            {entry.title}
                            {categoryName && ` (${categoryName})`}
                        </LinkComponent>
                    </Typography>
                    <Metadata entry={entry} />
                    {(entry.isMandatory || entry.certification) && (
                        <div className={classes.flags}>
                            {entry.isMandatory && (
                                <div className={classes.mandatoryFlagWrap}>
                                    <FlagButton variant="mandatory" />
                                </div>
                            )}
                            {entry.certification && (
                                <FlagButton
                                    variant={entry.certification.answer}
                                />
                            )}
                        </div>
                    )}
                </div>
            </div>
            <div className={`SummaryViewEntryListItem__descriptionwrap ${classes.entryDescription}`}>
                <TextWithReadMore 
                    text={entry.synopsis} length={320} color="textSecondary"
                    variant="subtitle1" className={classes.textWithReadMore} 
                />
            </div>
        </div>
    );
});